// Generated by purs version 0.13.8
"use strict";
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var DOM_HTML_Indexed_InputType = require("../DOM.HTML.Indexed.InputType/index.js");
var Data_Default = require("../Data.Default/index.js");
var Data_Function = require("../Data.Function/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Int = require("../Data.Int/index.js");
var Data_List = require("../Data.List/index.js");
var Data_Map_Internal = require("../Data.Map.Internal/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Monoid = require("../Data.Monoid/index.js");
var Data_Ord = require("../Data.Ord/index.js");
var Data_Show = require("../Data.Show/index.js");
var Data_Symbol = require("../Data.Symbol/index.js");
var Data_Tuple = require("../Data.Tuple/index.js");
var Data_Unfoldable = require("../Data.Unfoldable/index.js");
var Halogen_HTML = require("../Halogen.HTML/index.js");
var Halogen_HTML_Core = require("../Halogen.HTML.Core/index.js");
var Halogen_HTML_Elements = require("../Halogen.HTML.Elements/index.js");
var Halogen_HTML_Events = require("../Halogen.HTML.Events/index.js");
var Halogen_HTML_Properties = require("../Halogen.HTML.Properties/index.js");
var Lunarbox_Capability_Editor_Type = require("../Lunarbox.Capability.Editor.Type/index.js");
var Lunarbox_Component_Editor_HighlightedType = require("../Lunarbox.Component.Editor.HighlightedType/index.js");
var Lunarbox_Component_Editor_NodePreview = require("../Lunarbox.Component.Editor.NodePreview/index.js");
var Lunarbox_Component_Icon = require("../Lunarbox.Component.Icon/index.js");
var Lunarbox_Component_Utils = require("../Lunarbox.Component.Utils/index.js");
var Lunarbox_Data_Dataflow_Type = require("../Lunarbox.Data.Dataflow.Type/index.js");
var Lunarbox_Data_Editor_FunctionData = require("../Lunarbox.Data.Editor.FunctionData/index.js");
var Lunarbox_Data_Editor_FunctionName = require("../Lunarbox.Data.Editor.FunctionName/index.js");
var Lunarbox_Data_Editor_Location = require("../Lunarbox.Data.Editor.Location/index.js");
var Lunarbox_Data_Editor_Node_NodeDescriptor = require("../Lunarbox.Data.Editor.Node.NodeDescriptor/index.js");
var Lunarbox_Data_Editor_Node_PinLocation = require("../Lunarbox.Data.Editor.Node.PinLocation/index.js");
var Lunarbox_Data_Editor_State = require("../Lunarbox.Data.Editor.State/index.js");
var Lunarbox_Data_Ord = require("../Lunarbox.Data.Ord/index.js");
var resolvePin = function (v) {
    return function (type$prime) {
        if (v instanceof Lunarbox_Data_Editor_Node_PinLocation.InputPin) {
            return Data_List.index(Lunarbox_Data_Dataflow_Type.inputs(type$prime))(v.value0);
        };
        if (v instanceof Lunarbox_Data_Editor_Node_PinLocation.OutputPin) {
            return Data_Maybe.Just.create(Lunarbox_Data_Dataflow_Type.output(type$prime));
        };
        throw new Error("Failed pattern match at Lunarbox.Component.Editor.Add (line 54, column 1 - line 54, column 40): " + [ v.constructor.name, type$prime.constructor.name ]);
    };
};
var nodeButton = function (active) {
    return function (handleClick) {
        return function (iconName) {
            return Lunarbox_Component_Utils.whenElem(active)(function (v) {
                return Halogen_HTML_Elements.div([ Halogen_HTML_Events.onClick(Data_Function["const"](handleClick)) ])([ Lunarbox_Component_Icon.icon(iconName) ]);
            });
        };
    };
};
var makeNode = function (dictMonadEffect) {
    return function (v) {
        return function (v1) {
            return function (name) {
                return function (maxInputs) {
                    return function (typeMap) {
                        return function (inputCountMap) {
                            return function (functionData) {
                                var inputCount = Data_Maybe.fromMaybe(maxInputs)(Data_Map_Internal.lookup(Lunarbox_Data_Editor_FunctionName.ordFunctionName)(name)(inputCountMap));
                                return Halogen_HTML_Elements.div([ Lunarbox_Component_Utils.className("node") ])([ Halogen_HTML.slot()(new Data_Symbol.IsSymbol(function () {
                                    return "nodePreview";
                                }))(Lunarbox_Data_Editor_FunctionName.ordFunctionName)(Data_Symbol.SProxy.value)(name)(Lunarbox_Component_Editor_NodePreview.component(dictMonadEffect))({
                                    name: name
                                })(Data_Function["const"](v.updatePreview(name))), Halogen_HTML_Elements.div([ Lunarbox_Component_Utils.className("node__data") ])([ Halogen_HTML_Elements.div([ Lunarbox_Component_Utils.className("node__text") ])([ Halogen_HTML_Elements.header([ Lunarbox_Component_Utils.className("node__data-header") ])([ Halogen_HTML_Elements.div([ Lunarbox_Component_Utils.className("node__name no-overflow") ])([ Halogen_HTML_Core.text(Data_Show.show(Lunarbox_Data_Editor_FunctionName.showFunctionName)(name)) ]), nodeButton(v1.isUsable)(v.addNode(name))("add"), nodeButton(v1.isEditable)(v.edit(name))("edit"), nodeButton(v1.canBeDeleted)(v["delete"](name))("delete") ]), Halogen_HTML_Elements.section([ Lunarbox_Component_Utils.className("node__type") ])(Data_Maybe.fromMaybe(Data_Monoid.mempty(Data_Monoid.monoidArray))(Data_Functor.map(Data_Maybe.functorMaybe)((function () {
                                    var $37 = Control_Applicative.pure(Control_Applicative.applicativeArray);
                                    return function ($38) {
                                        return $37(Lunarbox_Component_Editor_HighlightedType.highlightTypeToHTML(Lunarbox_Capability_Editor_Type.prettify($38)));
                                    };
                                })())(Data_Map_Internal.lookup(Lunarbox_Data_Editor_Location.ordLocation)(new Lunarbox_Data_Editor_Location.AtFunction(name))(typeMap)))), Halogen_HTML_Elements.section([ Lunarbox_Component_Utils.className("node__currying") ])([ Halogen_HTML_Elements.div([ Lunarbox_Component_Utils.className("node__curying-text") ])([ Halogen_HTML_Core.text("inputs:") ]), Halogen_HTML_Elements.input([ Halogen_HTML_Properties.value(Data_Show.show(Data_Show.showInt)(inputCount)), Halogen_HTML_Properties.type_(Halogen_HTML_Core.isPropInputType)(DOM_HTML_Indexed_InputType.InputNumber.value), Halogen_HTML_Properties.min(0.0), Halogen_HTML_Properties.max(Data_Int.toNumber(maxInputs)), Lunarbox_Component_Utils.className("node__currying-input"), Halogen_HTML_Events.onValueInput(Control_Bind.composeKleisliFlipped(Data_Maybe.bindMaybe)(v.changeInputCount(name))((function () {
                                    var $39 = Data_Functor.map(Data_Maybe.functorMaybe)(Data_Ord.clamp(Data_Ord.ordInt)(0)(maxInputs));
                                    return function ($40) {
                                        return $39(Data_Int.fromString($40));
                                    };
                                })())) ]) ]) ]) ]) ]);
                            };
                        };
                    };
                };
            };
        };
    };
};
var add = function (dictMonadEffect) {
    return function (v) {
        return function (actions) {
            return Halogen_HTML_Elements.div([ Lunarbox_Component_Utils.className("nodes") ])(Data_Functor.map(Data_Functor.functorArray)(function (v1) {
                var functionData$prime = Data_Maybe.fromMaybe(Data_Default.def(Lunarbox_Data_Editor_FunctionData.defaultFunctionData))(Data_Map_Internal.lookup(Lunarbox_Data_Editor_FunctionName.ordFunctionName)(v1.value0)(v.functionData));
                return makeNode(dictMonadEffect)(actions)(v1.value1)(v1.value0)(Lunarbox_Data_Editor_State.getMaxInputs(v1.value0)(v))(v.typeMap)(v.inputCountMap)(functionData$prime);
            })(Lunarbox_Data_Ord.sortBySearch(Data_Tuple.ordTuple(Lunarbox_Data_Editor_FunctionName.ordFunctionName)(Data_Ord.ordRecord()(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordCons(Data_Ord.ordRecordNil)()(new Data_Symbol.IsSymbol(function () {
                return "isUsable";
            }))(Data_Ord.ordBoolean))()(new Data_Symbol.IsSymbol(function () {
                return "isEditable";
            }))(Data_Ord.ordBoolean))()(new Data_Symbol.IsSymbol(function () {
                return "canBeDeleted";
            }))(Data_Ord.ordBoolean))))((function () {
                var $41 = Data_Show.show(Lunarbox_Data_Editor_FunctionName.showFunctionName);
                return function ($42) {
                    return $41(Data_Tuple.fst($42));
                };
            })())(v.nodeSearchTerm)(Data_Map_Internal.toUnfoldable(Data_Unfoldable.unfoldableArray)(Lunarbox_Data_Editor_Node_NodeDescriptor.describe(v.currentFunction)(v.project)))));
        };
    };
};
module.exports = {
    add: add
};
